export default __webpack_public_path__ + "static/sustainability-model-c5a61e81ea14ff1beac1081b0e4fdcb4.png";